export default {
  black: `rgb(55, 55, 55)`,
  mutationRadius: 4,
}



// WEBPACK FOOTER //
// ./modules/~/@oncojs/lolliplot/theme.js